import React from 'react';

interface IconServiceCenterProps {
    iconClasses?: string;
}

const IconServiceCenter: React.FC<IconServiceCenterProps> = ({ iconClasses }) => {
    return (
        <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={`icon icon-service-center ${iconClasses ?? ''}`}
            aria-hidden="true"
        >
            <path
                d="M1.75 12.25V6.125L7 2.333L12.25 6.125V12.25"
                stroke="currentColor"
                strokeWidth="1.16667"
                strokeLinejoin="round"
            />
            <path d="M5.25 12.25V8.167H8.75V12.25" stroke="currentColor" strokeWidth="1.16667" strokeLinejoin="round" />
            <path d="M1.75 12.25H12.25" stroke="currentColor" strokeWidth="1.16667" strokeLinecap="round" />
        </svg>
    );
};

export default IconServiceCenter;
